import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CaretRightFilledSvg from "@ant-design/icons-svg/es/asn/CaretRightFilled";
import AntdIcon from "../components/AntdIcon";
var CaretRightFilled = function CaretRightFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretRightFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CaretRightFilled.displayName = 'CaretRightFilled';
}
export default /*#__PURE__*/React.forwardRef(CaretRightFilled);